var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideMyinfoImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3902 21.1098C27.2301 21.1098 28.0356 21.4434 28.6294 22.0373C29.2233 22.6312 29.5569 23.4366 29.5569 24.2765V25.0312C29.5569 28.8069 25.113 31.6654 19.0014 31.6654C12.8897 31.6654 8.4458 28.9558 8.4458 25.0312V24.2765C8.4458 23.4366 8.77943 22.6312 9.3733 22.0373C9.96716 21.4434 10.7726 21.1098 11.6125 21.1098H26.3902ZM19.0014 6.33203C19.8331 6.33203 20.6566 6.49585 21.425 6.81413C22.1934 7.13241 22.8916 7.59892 23.4797 8.18702C24.0678 8.77513 24.5343 9.47331 24.8526 10.2417C25.1709 11.0101 25.3347 11.8337 25.3347 12.6654C25.3347 13.4971 25.1709 14.3206 24.8526 15.089C24.5343 15.8574 24.0678 16.5556 23.4797 17.1437C22.8916 17.7318 22.1934 18.1983 21.425 18.5166C20.6566 18.8349 19.8331 18.9987 19.0014 18.9987C17.3217 18.9987 15.7107 18.3314 14.523 17.1437C13.3353 15.956 12.668 14.3451 12.668 12.6654C12.668 10.9857 13.3353 9.37475 14.523 8.18702C15.7107 6.99929 17.3217 6.33203 19.0014 6.33203Z",
    fill: "#9ED0BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMyinfoImg);
export default __webpack_public_path__ + "static/media/side-myinfo-img.e1154060371437ab397e136e32187c2d.svg";
export { ForwardRef as ReactComponent };